const RandomHeadImage = ({ items }) => {
  if (!items || items.length === 0) {
    return null;
  }

  const randomImage = items[Math.floor(Math.random() * items.length)];
  return <img src={randomImage} alt="Head" className="rand-head-img" />;
};

export default RandomHeadImage;